<template>
  <div
    class="component"
    @click.capture="toggle"
  >
    <input
      :id="htmlId"
      :disabled="disabled"
      :value="value"
      :checked="checkboxState"
      :required="required"
      class="styled-input"
      :class="labelPosition"
      v-bind="$attrs"
      data-inheritattrs
      type="checkbox"
    >
    <label
      :class="{ 'read-only' : readOnly }"
      class="label"
      :for="htmlId"
      @click="handleLabelClick"
    >
      <div
        v-if="hasLabel"
        :style="labelStyle"
      >
        <slot />
      </div>
    </label>
  </div>
</template>

<script>
import dynamicCustomInput from '@/components/common/input/mixins/dynamicCustomInput';
import selectionControl from '@/components/common/input/selection/mixin/selectionControl';

export default {
  name: 'NorticCheckbox',
  mixins: [selectionControl, dynamicCustomInput({
    prop: 'model', event: 'change', innerValue: 'modelValue', propTypes: [Boolean, Array],
  })],
  props: {
    isChecked: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    checkboxState() {
      return Array.isArray(this.model)
        ? this.modelValue.includes(this.value)
        : this.modelValue;
    },
  },
  watch: {
    isChecked(value) {
      if (value !== this.checkboxState) {
        this.toggle();
      }
    },
  },
  mounted() {
    if (this.isChecked && !this.checkboxState) {
      this.toggle();
    }
  },
  methods: {
    toggle() {
      if (!this.disabled && !this.readOnly) {
        if (Array.isArray(this.modelValue)) {
          this.checkArray();
        } else {
          this.modelValue = !this.modelValue;
        }

        this.$emit('change', this.modelValue, this.value);
      }
    },
    checkArray() {
      const index = this.modelValue.indexOf(this.value);

      if (index === -1) {
        this.modelValue.push(this.value);
      } else {
        this.modelValue.splice(index, 1);
      }
    },
    handleLabelClick(e) {
      if (e.target?.href) {
        e.stopImmediatePropagation();
      } else {
        e.preventDefault();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../style/selectionControl";

  .before {
    @include labelStyles(after, 3px);
  }

  .after {
    @include labelStyles(before, 3px);
  }
</style>
